import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearDynamicVariables } from "reducers/Assets";
import { closeModal } from "reducers/Modal";
import {
	Blade,
	Button,
	ProgressIndicator
} from "rhombus-react";
import { MODAL_TYPES } from "utils/constants";
import EmptySection from "widgets/EmptySection";
import VariablesTable from "widgets/table/VariablesTable";
import { isImposiumProject } from "utils/Assets";

import "./DynamicVariablesModal.css";

export default function DynamicVariablesModal() {
	const dispatch = useDispatch();
	let { variables, dynamicVariablesLoaded, modal, assetName, assetType } = useSelector((state) => {
		return {
			variables: state.assets.dynamicVariables.variables,
			dynamicVariablesLoaded: state.assets.dynamicVariables.dynamicVariablesLoaded,
			assetName: state.assets.dynamicVariables.assetName,
			assetType: state.assets.dynamicVariables.assetType,
			modal: state.modal,
		};
	});
	const bladeProps = { verticallyCenter: true };
	const emptySectionProps = {
		header: 'No Dynamic Variables',
		src: '/images/noFiles.svg',
	};

	const handleClose = () => {
		dispatch(closeModal());
		dispatch(clearDynamicVariables());
	};

	const renderContent = () => {
		let contentComponent = null;
		const isImposium = isImposiumProject(assetType);
		const assetTypeName = isImposium ? "Imposium project" : "After Effects package";
		const description = `Available dynamic variables within ${assetTypeName}:`;

		if (dynamicVariablesLoaded) {
			if (variables.length) {
				contentComponent = (
					<>
						<p className="description">{description}</p>
						<VariablesTable variables={variables} className="dynamic-variables-table" />
					</>
				);
			} else {
				contentComponent = <EmptySection {...emptySectionProps} />;
			}
		}

		return (
			<div className="dynamic-variables-container">
				<ProgressIndicator isLoading={!dynamicVariablesLoaded} />
				{contentComponent}
			</div>
		);
	};

	const renderFooter = () => {
		return <Button className="close-button" theme="grey" onClick={handleClose}>Close</Button>;
	};

	// guard clause
	if (!modal.isOpen || modal.modalType !== MODAL_TYPES.ASSET_DYNAMIC_VARIABLES) { return null; }

	return (
		<Blade
			type="modal"
			title={assetName ? `Dynamic Variables - ${assetName}` : "Dynamic Variables"}
			className = "dynamic-variables-modal"
			allowFullScreen={false}
			xClose={true}
			bladeProps={bladeProps}
			onClose={handleClose}
			renderContent={renderContent}
			renderFooter = {renderFooter}
		/>
	);
}
